import React, { useState } from "react";
import { Box } from "@mui/material";
import { colors, fonts } from "../../theme/tokens";
import { faq } from "../../data/faqs";

const Faqs = () => {
  const [open, setOpen] = useState(faq.length ? faq[0].id : null);

  return (
    <Box
      id="faqs"
      component="section"
      sx={{ pt: "30px", pb: "80px", px: { xs: "20px", md: "28px" } }}
    >
      <Box sx={{ maxWidth: "880px", mx: "auto" }}>
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: "36px" }}>
          <Box
            sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}
          >
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
            <Box
              sx={{
                fontFamily: fonts.display,
                fontSize: "12.5px",
                fontWeight: 600,
                letterSpacing: ".2em",
                color: colors.steelBlue,
              }}
            >
              FAQs
            </Box>
            <Box
              sx={{ width: "26px", height: "2px", background: colors.amber }}
            />
          </Box>
          <Box
            component="h2"
            sx={{
              fontFamily: fonts.display,
              fontWeight: 700,
              fontSize: "clamp(26px,3.2vw,38px)",
              lineHeight: 1.1,
              color: colors.navyInk,
              mt: "16px",
              mb: 0,
            }}
          >
            Frequently asked questions
          </Box>
        </Box>

        {/* Accordion */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {faq.map((item) => {
            const isOpen = open === item.id;
            return (
              <Box
                key={item.id}
                sx={{
                  background: "#fff",
                  border: `1px solid ${colors.lineSoft}`,
                  borderRadius: "18px",
                  overflow: "hidden",
                }}
              >
                <Box
                  component="button"
                  onClick={() => setOpen(isOpen ? null : item.id)}
                  sx={{
                    cursor: "pointer",
                    width: "100%",
                    background: "none",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    p: "20px 24px",
                    textAlign: "left",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: fonts.display,
                      fontWeight: 600,
                      fontSize: "16.5px",
                      color: colors.brandNavy,
                    }}
                  >
                    {item.question}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      flex: "none",
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      transition: "transform .25s, background .25s, color .25s",
                      background: isOpen ? colors.amber : "#F4F7FB",
                      color: isOpen ? "#fff" : colors.steelBlue,
                      transform: isOpen ? "rotate(45deg)" : "none",
                    }}
                  >
                    +
                  </Box>
                </Box>
                {isOpen && (
                  <Box
                    sx={{
                      px: "24px",
                      pb: "22px",
                      fontFamily: fonts.body,
                      fontSize: "15px",
                      lineHeight: 1.65,
                      color: colors.mutedText,
                    }}
                  >
                    {item.answer}
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Faqs;
